import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MembershipPointsCurrencyContainerModel} from '../../../../../../models/aggregates/crm/membership-points-currency';
import {BaseApiTemplateService, Core2Config} from '../../shared';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';


@Injectable({
  providedIn: 'root'
})
export class MembershipPointsCurrencyService extends BaseApiPublicLoginTemplateService<MembershipPointsCurrencyContainerModel, MembershipPointsCurrencyContainerModel, MembershipPointsCurrencyContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + 'membership-points-currency';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + 'membership-points-currency';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + 'membership-points-currency';
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + 'membership-points-currency/' + BaseApiTemplateService.PUBLIC_EP;
    this.endpoint_path_website_ep_url = Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + 'membership-points-currency/' + BaseApiTemplateService.WEBSITE_EP;
    this.httpClient = http;
  }
}


